// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { getImplementation } from '../../../../new-order/CheckoutStep/PaymentImpl';
import { animateScroll as scroll } from 'react-scroll';
import { Link } from 'react-router-dom';
import DeleteModal from '../../components/DeleteModal/DeleteModal';
import FloatingBottom from '../../../../../elements/FloatingBottom/FloatingBottom';
import CourierInfo from "../../components/CourierInfo/CourierInfo";

import commonStyle from '../../../components/OrderCommon.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import style from './UnconfirmedPayment.scss';

import type { Node } from 'react';
import type { Order } from '../../../../../entities';
import type { PaymentImpl } from '../../../../new-order/CheckoutStep/PaymentImpl';
import type { HTTPError } from '../../../../../error';
import type { LocalValuesState } from "../../../../local-values/duck";

type Props = {
  +localValues: LocalValuesState;
  +buildProducts: () => Node;
  +buildSummary: () => Node;
  +order: Order;
  +isDeletingOrder: boolean;
  +deleteSuccess: boolean;
  +deleteOrderError: HTTPError;
  +deleteOrder: (orderId: string) => void;
};

type State = {
  openModal: boolean;
};

const messages = defineMessages({
  unconfirmedPaymentFirst: {
    id: 'order.purchase.unconfirmedPayment.text.first',
  },
  unconfirmedPaymentSecond: {
    id: 'order.purchase.unconfirmedPayment.text.second',
  },
  unconfirmedPaymentThird: {
    id: 'order.purchase.unconfirmedPayment.text.third',
  },
  bitPay: {
    id: 'order.purchase.unconfirmedPayment.bitPay',
  },
  safetyPay: {
    id: 'order.purchase.unconfirmedPayment.safetyPay',
  },
});

export default class UnconfirmedPayment extends Component<Props, State> {
  state = {
    openModal: false,
  };

  componentDidUpdate(prevProps: Props): void {
    const { deleteOrderError } = this.props;
    if (deleteOrderError && prevProps.deleteOrderError !== deleteOrderError) {
      this.setState({ openModal: false });
      scroll.scrollTo(0, {
        duration: 400,
      });
    }
  }

  handleOpenModal = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  showPaymentData = (paymentData: string, paymentImpl?: ?PaymentImpl) => {
    if (paymentImpl && paymentImpl.showPopUp) {
      paymentImpl.showPopUp(paymentData);
    }
  };

  render() {
    const { localValues, buildProducts, buildSummary, order, deleteOrder, isDeletingOrder } = this.props;
    const { openModal } = this.state;
    let popUpData = '';
    let paymentMethodName = '';
    let paymentImpl: ?PaymentImpl;
    if (order.invoice && order.invoice.payment) {
      if (order.invoice.payment.method === 'BITPAY') {
        paymentMethodName = 'BitPay';
        paymentImpl = getImplementation('bitpay');
        popUpData = order.invoice.payment.paymentData.id;
      } else if (order.invoice.payment.method === 'SAFETYPAY') {
        paymentMethodName = 'SafetyPay';
        paymentImpl = getImplementation('safetypay');
        popUpData = order.invoice.payment.paymentData.shopperRedirectUrl;
      } else if (order.invoice.payment.method === 'KASHIO') {
        paymentMethodName = 'Kashio';
        paymentImpl = getImplementation('kashio');
        popUpData = order.invoice.payment.paymentData.shopperRedirectUrl;
      }
    }
    const totalServicesCost = parseFloat(order.invoice.detail.importationFee) +
      parseFloat(order.invoice.detail.customsDuties) +
      parseFloat(order.invoice.detail.qempo) +
      parseFloat(order.invoice.detail.lastMileShipping);
    return (
      <Fragment>
        <section className={commonStyle.topWrap}>
          <FormattedMessage id="order.purchase.unconfirmedPayment.title">{
            txt => <h2 className={commonStyle.topTitle}>{txt}</h2>
          }</FormattedMessage>
        </section>
        <main className={commonStyle.mainWrap}>
          <section className={classNames(commonStyle.wrap, commonStyle.leftWrap)}>
            {!!paymentImpl &&
            <section className={classNames(boxStyle.box, style.box)}>
              <p className={classNames(boxStyle.subtitle, boxStyle.noSpace)}>&nbsp;
                {this.context.intl.formatMessage(messages.unconfirmedPaymentFirst)}&nbsp;
                {this.context.intl.formatMessage(messages.unconfirmedPaymentSecond)}&nbsp;
                {paymentMethodName}&nbsp;
                {this.context.intl.formatMessage(messages.unconfirmedPaymentThird)}
              </p>
              <FormattedMessage id="order.purchase.unconfirmedPayment.button.payment.code">{
                txt => <button className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                               onClick={() => this.showPaymentData(popUpData, paymentImpl)}>
                  {txt}</button>
              }</FormattedMessage>
            </section>}
            {(order.invoice.payment.method === 'MANUAL_TRANSFER' ||
              order.invoice.payment.method === 'MANUAL_TRANSFER_SOLES') && (
              <section className={classNames(boxStyle.box, style.box)}>
                <p className={boxStyle.subtitle}>¿Cómo pagar?</p>
                {/*<FormattedMessage id="newOrder.checkout.review.paymentMethod">{
                  txt => <p className={boxStyle.subtitle}>{txt}</p>
                }</FormattedMessage>*/}
                <p className={boxStyle.content}>
                  Realiza el depósito en banco o transferencia bancaria del monto total del pedido a la
                  siguiente cuenta: <br/><br/>
                  Colaboratec SAC (Empresa recaudadora de fondos para Qempo LLC)<br/>
                  RUC: 20602353924<br/><br/>
                  Cuenta en dólares:<br/>
                  Banco BCP<br/>
                  BCP USD: 193-2316407-1-59<br/>
                  CCI: 00219300231640715911<br/><br/>
                  Cuenta en soles:<br/>
                  Banco BCP Cuenta Corriente<br/>
                  BCP: 194-8742188-0-27<br/>
                  CCI: 00219400874218802796<br/><br/>
                  Una vez realizado el pago, envía la constancia a hola@qempo.com indicando tu número de
                  pedido {order.id}<br/>
                </p>
              </section>
            )}
            {!!order.shipments && order.shipments.length > 0 &&
            !!order.invoice && !!order.invoice.detail &&
            <section className={style.courier}>
              <CourierInfo localValues={localValues}
                           courier={order.shipments[0].courier}
                           servicesCost={totalServicesCost}/>
            </section>}
            {buildProducts()}
          </section>
          <section className={classNames(commonStyle.wrap, commonStyle.rightWrap)}>
            {buildSummary()}
            <FormattedMessage id="order.purchase.unconfirmedPayment.changePayment.button">{
              txt => <Link to={`/new-order/checkout/order/${order.id}`}
                           className={classNames(buttonStyle.btn, buttonStyle.darkGrey, style.change)}>{txt}
              </Link>
            }</FormattedMessage>
            <FormattedMessage id="order.purchase.unconfirmedPayment.deleteOrder.button">{
              txt => <button onClick={this.handleOpenModal}
                             className={classNames(buttonStyle.btn, buttonStyle.redInverse, style.change)}>{txt}
              </button>
            }</FormattedMessage>
          </section>
          <section className={style.buttonsWrap}>
            <FloatingBottom offSetY={152}>
              <FormattedMessage id="order.purchase.unconfirmedPayment.changePayment.button">{
                txt => <Link to={`/new-order/checkout/order/${order.id}`}
                             className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}>{txt}
                </Link>
              }</FormattedMessage>
              <FormattedMessage id="order.purchase.unconfirmedPayment.deleteOrder.button">{
                txt => <button onClick={this.handleOpenModal}
                               className={classNames(buttonStyle.btn, buttonStyle.redInverse, style.below)}>{txt}
                </button>
              }</FormattedMessage>
            </FloatingBottom>
          </section>
        </main>
        <DeleteModal modalVisible={openModal}
                     orderId={order.id}
                     handleClose={this.handleCloseModal}
                     isDeleting={isDeletingOrder}
                     deleteOrder={deleteOrder}/>
      </Fragment>
    );
  }
}

UnconfirmedPayment.propTypes = {
  localValues: PropTypes.object.isRequired,
  buildProducts: PropTypes.func.isRequired,
  buildSummary: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  isDeletingOrder: PropTypes.bool,
  deleteSuccess: PropTypes.bool,
  deleteOrderError: PropTypes.object,
  deleteOrder: PropTypes.func.isRequired,
};

UnconfirmedPayment.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/order/Purchase/unconfirmed-payment/components/UnconfirmedPayment.jsx